const notifications = (state = 0, action) => {
  switch (action.type) {
    case 'SET':
      return action.unread;
    default:
      return state;
  }
};

export default notifications;